<template>
    <div>
        <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="sampleForm" :refresh-key="refreshKey" :show-expand="false">
            <template v-slot:buttons="{ item }">
                <v-btn v-if="isEmpty(item.sampleSetId)" color="tertiary" dark class="mr-2 float-right" @click.stop="addTests(item)" @click.stop.prevent>Add Tests</v-btn>
            </template>
        </table-base>
        <v-dialog v-model="testSelectionDialog" max-width="750px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
            <test-selection-form :filter="filter" v-model="editedItem" @cancel="testSelectionDialog = false" @open="testSelectionDialog = true" :key="formKey" />
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
            testSelectionForm: () => import('@/forms/TestSelectionForm')
        },
        data() {
            return {
                sampleForm: () => import('../forms/SampleForm'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Code', value: 'code' },
                    { text: 'Harvesting', value: 'harvestingId', table: 'harvestings', form: () => import('../forms/HarvestingForm') },
                    { text: 'Floral Variety', value: 'floralVarietyId', table: 'floralVarieties', form: () => import('../forms/FloralVarietyForm') },
                    { text: 'Coordinates', value: 'coordinates', format: this.formatCoordinates },
                    { text: 'Temperature', value: 'temperature' },
                    { text: 'Sample Storage', value: 'sampleStorage', format: this.formatEnum },
                    { text: 'Is Filtered', value: 'isFiltered' },
                    { text: 'Is For Testing', value: 'isForTesting' },
                    { text: 'Is Member Sample', value: 'isMemberSample' },
                    { text: 'Created On', value: 'createdOn', format: this.formatDate },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    sampleSets: [],
                    floralVarieties: [],
                    harvestings: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "createdOn", direction: "descending" },
                    { column: "code", direction: "ascending" },
                    { column: "floralVarietyId", direction: "ascending" },
                ],
                itemsField: 'samples',
                editPageName: 'sample',
                apiMethod: 'Samples',
                claimName: 'Samples',
                formTitle: 'Sample',
                excelTitle: 'Samples',
                hasEditPage: true,
                testSelectionDialog: false,
                editedItem: null,
                formKey: 0
            }
        },
        methods: {
            addTests(item) {
                this.testSelectionDialog = true;
                this.editedItem = item;
            }
        }
    };
</script>
